import React, { useEffect, useState } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import { atomobj } from '../C';
import { useRecoilState } from 'recoil';
import { useNavigate } from 'react-router-dom';

function SingleMAP({ coordinate,colour }) {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false);
  const [isScriptLoadSucceed, setIsScriptLoadSucceed] = useState(true);
  const [zoom, setZoom] = useState(1); // Initialize zoom to 1

  const handleScriptLoad = () => {
    setIsScriptLoaded(true);
  };

  const nav = useNavigate();

  const [msg, setmsg] = useRecoilState(atomobj);

  useEffect(() => {
    console.log(msg);
    if (msg === "RECOILATOMISEMPTY") {
      nav('/');
    }
  }, []);

  const handleScriptError = () => {
    setIsScriptLoaded(false);
    console.error('Error loading Google Maps script');
  };

  const isMobile = window.innerWidth <= 768; // Adjust the breakpoint as needed

  const mapContainerStyle = {
    width: isMobile ? '100%' : '100%',
    height: isMobile ? '250px' : '400px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  };
  const initialCenter = coordinate
    ? {
        lat: parseFloat(coordinate.split(',')[1]),
        lng: parseFloat(coordinate.split(',')[0]),
      }
    : {
        lat: 20.5937, // Latitude of India
        lng: 78.9629,
      };

  useEffect(() => {
    console.log(coordinate);
  }, [coordinate]);

  useEffect(() => {
    // Update the zoom level every 1 second (adjust the timing as needed)
    const zoomInterval = setInterval(() => {
      if (zoom < 8) {
        setZoom(zoom + 1);
      }
    }, 500);

    // Clear the interval when the component unmounts
    return () => clearInterval(zoomInterval);
  }, [zoom]);



  const markerIcons = {
    orange: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAP1BMVEX/pQD/ogD/0qD/16P/oAD/3Kv/4bT/5r//68v/5bz/8t//ngD/nAD/0Jr///7/+fP/9eX/8Nn/7dH/3q7/6NBAdwNKAAABcUlEQVR4nO3dSWrDQBBAUXmS4inz/c8aG7JJNjaGEJ703wGa+suGghqeX17f3p+epmnajxe7b5uf1o/b3LS7x8d4j+m3/WEYT8eL7S2rR918+W+dzsO4HeZstV5A4cfsC3cV2ir0Veir0Fehr0LfIgo3Fdoq9FXoq9BXoa9CX4W+Cn0V+ir0Veir0Fehr0Jfhb4KfYsoXK/+e4g/VaGvQl+Fvgp9Ffoq9FXoq9BXoa9CX4W+Cn0V+ir0Veir0Fehr0Jfhb5r4ez3aea/MVQhrkJfhb4KfRX6KvRV6KvQV6GvQl+Fvgp9Ffoq9FXoq9BXoa9CX4W+Cn2LuMJSIa5CX4W+Cn0V+ir0Veir0Fehr0Jfhb4KfRX6KvRV6KvQV6GvQt+lcKzQVqGvQl+Fvgp9Ffoq9FXoq9BXoa9CX4W+Cn0V+ir0Veir0FehbxGF+9kXThXaKvRV6KvQV6GvQl+Fvgp91x/waTVnx/NwOK/n7Pz5BdM1Ezx5aK1QAAAAAElFTkSuQmCC',
    red: 'https://freesvg.org/img/1286146771.png',
    yellow: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/Square_Yellow.svg/480px-Square_Yellow.svg.png',
  };

  // Get the marker icon URL based on the 'colour' prop
  const markerIconUrl = markerIcons[colour] || 'DEFAULT_URL_FOR_OTHER_COLORS';

  return (
    <LoadScript
      googleMapsApiKey="AIzaSyAPEgecVTqBmxZC1D6SIhcp01caAwqZj3I
      "
      onLoad={handleScriptLoad}
      onError={handleScriptError}
    >
      {isScriptLoadSucceed && (
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={initialCenter}
          zoom={zoom} // Use the dynamic zoom level
        >
          {coordinate && (
            <Marker
              position={{
                lat: parseFloat(coordinate.split(',')[1]),
                lng: parseFloat(coordinate.split(',')[0]),
              }}
              icon={{
                url: markerIconUrl,

                scaledSize: new window.google.maps.Size(40, 40),
              }}
            />
          )}
        </GoogleMap>
      )}
    </LoadScript>
  );
}

export default SingleMAP;
